import React                       from 'react';
import PropTypes                   from 'prop-types';
import FooterRow                   from './../Base/Footer/FooterRow';
import FooterColumn                from './../Base/Footer/FooterColumn';
import FooterLabel                 from './../Base/Footer/FooterLabel';
import {formatDuration, mergeDeep} from '../../../../utils/CommonUtils';
import Footer                      from './../Base/Footer/Footer';
import Flux                        from '../../../../flux/Flux';
import {TileDisplayConfigType}     from '../../Grid2';
import ReloadHelper                from '../../../../utils/ReloadHelper';
import {ModelInterviewType}        from './InterviewTilePropTypes';

const FooterLabelStyles = Flux.Constants.Grid2.Footer.Label.Styles;

const InterviewTileFooter = props => {
	const data          = props.data;
	const displayConfig = props.displayConfig;
	const config        = mergeDeep({}, InterviewTileFooter.defaultProps.config, props.config);

	const onActorNameClick    = e => ReloadHelper.reload(data.model.linkVX, e);
	const applyDurationFormat = config.duration.format === Flux.Constants.Interviews.DURATION_SEC;

	return (
		<Footer displayConfig={displayConfig}>
			<FooterRow>
				<FooterColumn grow={true} shrink={true}>
					<FooterRow>
						<FooterLabel labelStyle={FooterLabelStyles.TITLE}>{data.title}</FooterLabel>
					</FooterRow>
					<FooterRow>
						<FooterColumn grow={true} shrink={true}>
							<FooterLabel labelStyle={FooterLabelStyles.SUBTITLE}>
								({applyDurationFormat ? formatDuration(data.duration) : data.duration + ' ' + config.duration.format})
							</FooterLabel>
						</FooterColumn>
						<FooterColumn>
							<FooterLabel labelStyle={FooterLabelStyles.ACTOR_NAME}>
								<a href={data.model.linkVX} onClick={onActorNameClick}>{data.model.name}</a>
							</FooterLabel>
						</FooterColumn>
					</FooterRow>
				</FooterColumn>
			</FooterRow>
		</Footer>
	);
};

export const InterviewTileFooterConfigType = PropTypes.shape({
	duration: PropTypes.shape({
		format:   PropTypes.oneOf([
			Flux.Constants.Interviews.DURATION_SEC,
			Flux.Constants.Interviews.DURATION_MIN,
		]),
	}),
});

InterviewTileFooter.propTypes = {
	data:          ModelInterviewType.isRequired, // VXQL ModelInterview type
	config:        InterviewTileFooterConfigType,
	displayConfig: TileDisplayConfigType,
};

InterviewTileFooter.defaultProps = {
	config: {
		duration: {
			format: Flux.Constants.Interviews.DURATION_MIN,
		},
	},
};

export default InterviewTileFooter;
